import { Box, Typography } from "@mui/material";
import CollapseQuestions from "./Collapse";
import SectionImage, {
  hasSectionImage,
} from "pages/Courses/AdquireCourse/Sections/SectionImage";
import { isEnabled } from "utils/booleans";

const Questions = ({ props }) => {
  const {
    show_section3,
    questions,
    section3_title,
    section3_bgColor_1,
    section3_bgColor_2,
    section3_use_image,
    section3_image,
    section3_mobile_image,
  } = props;

  if (!isEnabled(show_section3)) return null;
  if (
    section3_use_image &&
    hasSectionImage(section3_image, section3_mobile_image)
  ) {
    return (
      <SectionImage
        image={section3_image}
        mobileImage={section3_mobile_image}
        alt="Perguntas frequentes"
      />
    );
  }

  return (
      <section
        style={{
          padding: "6rem 0",
          // minHeight: "100vh",
          justifyContent: "center",
          alignItems: "center",
          display: "flex",
          position: "relative",
          background: `linear-gradient(180deg, ${section3_bgColor_1} 0%, ${section3_bgColor_2} 100%)`,
        }}
      >
        <Typography
          variant="h5"
          sx={{
            fontWeight: "bold",
            textAlign: "center",
            color: "black",
            position: "absolute",
            top: "0",
            left: "50%",
            transform: "translateX(-50%)",
          }}
        >
          Seção 6
        </Typography>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            gap: "4rem",
            zIndex: 10,
            width: "100%",
            position: "relative",
          }}
        >
          <Typography
            variant="h2"
            sx={{
              marginBottom: "1rem",
            }}
            dangerouslySetInnerHTML={{ __html: section3_title }}
          />
          <div
            style={{
              borderRadius: "0.8rem",
              padding: "0.4rem 1rem",
              borderRadius: "0.8rem",
              overflow: "hidden",
              display: "flex",
              flexDirection: "column",
              gap: "1rem",
            }}
          >
            {questions?.map((question, index) => (
              <CollapseQuestions
                key={index}
                question={question["question"]}
                answer={question["answer"]}
              />
            ))}
          </div>
        </div>
      </section>
  );
};

export default Questions;
